/**
 * Определяет операционную систему пользователя
 * @returns {string} Название операционной системы
 */
export function detectOS(): string {
  const userAgent = navigator.userAgent.toLowerCase();
  const platform = navigator.platform.toLowerCase();

  // Проверяем мобильные устройства
  if (/android/.test(userAgent)) {
    return 'Android';
  }
  
  if (/iphone|ipad|ipod/.test(userAgent) || /mac/.test(platform) && 'ontouchend' in document) {
    return 'iOS';
  }

  // Проверяем десктопные системы
  if (/mac/.test(platform) || /mac/.test(userAgent)) {
    return 'macOS';
  }
  
  if (/win/.test(platform) || /windows/.test(userAgent)) {
    return 'Windows';
  }
  
  if (/linux/.test(platform) || /linux/.test(userAgent)) {
    return 'Linux';
  }

  // Если не удалось определить, возвращаем неизвестную систему
  return 'Unknown';
}
